import { DeparturePriceResponse, DepartureResourceResponse, DepartureTicketTypeResponse } from "../api/DeparturePriceResponse";
import { TicketTypeEnum } from "../enums";
import { Extra } from "./Extra";
import { ISO8601 } from '../../helpers/dateHelper';

export class DeparturePrice {
    departureDate: Date;
    arrivalDate: Date;
    fromDestination: string;
    toDestination: string;
    route: string;
    capacity: number;
    price: number;
    disabled: boolean;
    isCruisePrice: boolean;
    departureId: string;
    identifier: string;
    ticketTypes: DepartureTicketType[];
    hasFlexi: boolean;
    transfer?: Extra;
    bookable: boolean;
    message: string;

    constructor(resp: DeparturePriceResponse) {
        this.departureId = `${resp.route}|${ISO8601(resp.departureDateTime)}`;
        const ticketTypes = resp.alternatives?.map(t => new DepartureTicketType(t, this.departureId)) ?? [];

        //Standard is the default even on Daytrips (I've been told...)
        const ticketType = ticketTypes.find(x => x.type === TicketTypeEnum[TicketTypeEnum.Standard]) ?? {} as DepartureTicketType;

        this.departureDate = new Date(resp.departureDateTime) ?? new Date();
        this.arrivalDate = new Date(resp.arrivalDateTime) ?? new Date();
        this.fromDestination = resp.route.substring(0, 3);
        this.toDestination = resp.route.substring(3, 6);
        this.route = resp.route;
        this.disabled = false;
        this.bookable = resp.isBookable;
        this.message = resp.message;
        this.capacity = resp.capacity;
        this.price = ticketType.price ?? 0;
        this.isCruisePrice = resp.isCruisePrice;
        this.identifier = ticketType.identifier;
        this.ticketTypes = ticketTypes;
        this.hasFlexi = ticketTypes.filter(t => t.type === TicketTypeEnum[TicketTypeEnum.Flexi])?.length > 0;
        this.transfer = resp.transfer ? new Extra(resp.transfer) : undefined;
    }
}

export class DepartureTicketType {
    identifier: string;
    title?: string;
    type: string;
    price: number;
    body?: string;
    bookable: boolean;
    id: string;

    constructor(resp: DepartureTicketTypeResponse, departureId: string) {
        this.id = `${departureId}|${resp.type}`;
        this.identifier = resp.identifier;
        this.type = resp.type;
        this.price = resp.price;
        this.bookable = resp.bookable;
    }
}

export class DepartureResource {
    code: string;
    price: number;
    identifier: string;
    capacity: number;

    constructor(resp: DepartureResourceResponse) {
        this.code = resp.code;
        this.price = resp.price;
        this.identifier = resp.identifier;
        this.capacity = resp.capacity;
    }
}